import { render, staticRenderFns } from "./_PdfView.vue?vue&type=template&id=795bc6f0"
import script from "./_PdfView.vue?vue&type=script&lang=js"
export * from "./_PdfView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports